import { useCallback, useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { GameLoopContext } from '../../GameLoopContext/GameLoopContext';

export default function useSprite({
  spriteId,
  animId,
  gameAssets,
  onAnimationLastFrame,
}) {
  const gameLoop = useContext(GameLoopContext);
  const { state, actions } = useCustomHook({
    defaultState: {
      currentFrame: null,
      currentFrameNumber: 0,
      curAnimFrames: null,
      responsiveTransform: null, // position in pixels and scaleX and scaleY as scale ratios for CSS
    },
  });

  // Initial sprite animation state
  useEffect(() => {
    const curAnimFrames = getFrames(spriteId, animId);

    actions.setState({
      curAnimFrames,
      currentFrameNumber: 0,
      currentFrame: curAnimFrames[0],
    });
  }, [spriteId, animId]);

  // SpriteSheet frame updates
  useEffect(() => {
    if (state.curAnimFrames) {
      const currentFrameNumber =
        (state.currentFrameNumber + 1) % state.curAnimFrames.length;
      const currentFrame = state.curAnimFrames[state.currentFrameNumber];

      actions.setState({
        currentFrameNumber,
        currentFrame,
      });

      const isLastFrame =
        state.currentFrameNumber == state.curAnimFrames.length - 1;
      if (isLastFrame && onAnimationLastFrame) {
        onAnimationLastFrame(animId);
      }
    }
  }, [gameLoop.state.frame]);

  const getFrames = useCallback(
    (spriteId, animId) => {
      const spriteData = gameAssets.state.sprites[spriteId];
      return (
        spriteData?.[animId]?.frames ??
        spriteData.default?.frames ??
        spriteData.normal?.frames
      );
    },
    [spriteId, animId, gameAssets.state.sprites]
  );

  return { state, actions };
}
